import {
  Button,
  DialogActions,
  DialogContent,
  LabelChip,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { AgentCodeSnippet } from 'components/code';
import { useGpuExporterScriptQuery } from 'hooks/queries/cost';

import { AssignCredentialsDialogHeader } from '../../../_components/AssignCredentialsDialogHeader';

import { getDocsLink } from '@cast/utils';

type Props = {
  onClose: () => void;
  clusterId: string;
  onRunScriptClick: () => void;
};

export const RunTheScriptSlide = ({
  onClose,
  clusterId,
  onRunScriptClick,
}: Props) => {
  const { isLoading, data, error, refetch } = useGpuExporterScriptQuery({
    clusterId,
  });

  return (
    <Stack position="relative">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent sx={{ pb: 0 }}>
        <Stack gap={12} mb={16}>
          <Stack direction="row" alignItems="center" gap={12}>
            <Typography variant="h6">Enable deeper GPU metrics</Typography>
            <LabelChip
              size="sm"
              sx={{
                backgroundColor: 'blue.400',
                color: '#fff',
              }}
            >
              NEW
            </LabelChip>
          </Stack>
          <Typography variant="P12R" color="textSecondary">
            Gain advanced GPU metrics across your Kubernetes clusters. Monitor
            GPU utilization, memory usage, and performance across nodes, pods,
            and containers to optimize resource allocation and workload
            efficiency.{' '}
            <ExternalLink
              sx={{ typography: 'P12R' }}
              link={getDocsLink('docs_gpu_metrics_exporter')}
            >
              Documentation
            </ExternalLink>
          </Typography>
        </Stack>

        <Typography
          variant="L10M"
          color={tokens.theme.fg.structural.secondary}
          mb={8}
        >
          RUN THE SCRIPT:
        </Typography>
      </DialogContent>
      <DialogContent sx={{ py: 16, backgroundColor: 'grey.100' }}>
        <AgentCodeSnippet
          code={data}
          isLoading={isLoading || !data}
          error={error}
          refetch={refetch}
        />
      </DialogContent>
      <DialogActions sx={{ py: 16 }}>
        <Button onClick={onRunScriptClick} testId="i-ran-script-button">
          I ran the script
        </Button>
      </DialogActions>
    </Stack>
  );
};
